export const RECORDING_DEMO_STORAGE_KEY =
  "pdfparse-recording-demo-environments-v4";
export const CONVERTER_DEMO_STORAGE_KEY = "pdfparse-converter-demo-v1";
export const DEMO_ENVIRONMENT_RESET_EVENT = "pdfparse-demo-environment-reset";

export type ConverterDemoStatus = "empty" | "processing" | "ready";

export function resetProjectDemo() {
  window.localStorage.removeItem(RECORDING_DEMO_STORAGE_KEY);
  window.dispatchEvent(new Event(DEMO_ENVIRONMENT_RESET_EVENT));
}

export function resetConverterDemo() {
  window.localStorage.setItem(CONVERTER_DEMO_STORAGE_KEY, "empty");
  window.dispatchEvent(new Event(DEMO_ENVIRONMENT_RESET_EVENT));
}

export function resetAllDemos() {
  resetProjectDemo();
  resetConverterDemo();
}
